
<template>
  <div class="product-head">
    <div class="product-head-bg">
      <img
        :src="img | imgFilter('/images/vacances-en-laponie-en-hiver-707.jpg')"
        class="no-resize"
        data-width="1920"
        data-height="1040" />
    </div>

    <div class="page-head-container">
      <div class="title ft-40">{{ title }}</div>
      <div class="sub ff-dr ft-25">{{ sub }}</div>
    </div>

    <div class="page-head-bottom">
      <div class="wrap">
        <div class="page-head-bottom-item">
          <div class="name">
            <span class="big ft-26">{{$t('product.head[0]')}}</span>
            <span class="small ft-16">Products</span>
          </div>
          <div class="info ft-14">
            {{ products }}
          </div>
        </div>
        <div class="page-head-bottom-item">
          <div class="name">
            <span class="big ft-26">{{$t('product.head[1]')}}</span>
            <span class="small ft-16">Net Weight/Drain Weight</span>
          </div>
          <div class="info ft-14">
            {{ weight }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: String,
    title: String,
    sub: String,
    products: String,
    weight: String
  }
}
</script>

<style lang="scss" scoped>
.product-head {
  height: 100vh;
  overflow: hidden;
  width: 100%;
  position: relative;
  background-color: #242a3a;
}

.product-head:after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 200px;
  left: 0;
  z-index: 2;
  background: -webkit-gradient(linear,left top,left bottom,from(rgba(36,42,58,0)),color-stop(80%,#242a3a));
  background: linear-gradient(rgba(36,42,58,0),#242a3a 80%);
}

.product-head-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.15;
}

.page-head-container {
  text-align: center;
  position: relative;
  width: 100%;
  z-index: 3;
  top: 53%;
  transform: translateY(-50%) translateZ(0);

  .title {
    color: #fff;
    line-height: 100px;
  }
  .sub {
    color: #fff;
    line-height: 50px;
  }
}

.page-head-bottom {
  font-size: 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  max-width: 1280px;
  z-index: 3;
  left: 50%;
  box-sizing: border-box;
  transform: translateX(-50%);

  .wrap {
    width: 100%;
    display: flex;
  }
}

.page-head-bottom:after {
  content: "";
  display: block;
  height: 1px;
  position: absolute;
  bottom: 0;
  background-color: #fff;
  opacity: 0.1;
  width: 100%;
  left: 0;
}

.page-head-bottom-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 32px;

  .name {
    color: #c5e3f7;
    display: flex;
    align-items: baseline;

    span {
      display: inline-block;
      padding: 16px 4px;
    }
  }
  .info {
    padding: 4px;
    color: #fff;
    line-height: 32px;
    word-break: break-all;
  }
}
@media(max-width: 768px){
  .product-head{
    height: auto;
    &::after{
      display: none;
    }
  }
  .product-head-bg{
    position: static;
    height: auto;
  }
  .page-head-container{
    transform: translate(0);
    top: 0;
    .title{
      font-size: 20px;
      line-height: 50px;
    }
  }
  .page-head-bottom{
    position: static;
    transform: translate(0);
    .wrap{
      flex-direction: column;
      .page-head-bottom-item .name .big{
        font-size: 20px;
      }
    }
  }
}
</style>
